import * as React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SLIDES_CONFIG_KEY, SLIDES_DEFAULT, TCompareFlightSlides } from './constants';
import { SliderModalLoadable } from './loadable';

export interface INewbuildingCompareFlightModalContainerProps {
  onClose(): void;
}

export const NewbuildingCompareFlightModalContainer: React.FC<INewbuildingCompareFlightModalContainerProps> = ({
  onClose,
}) => {
  const { config } = useApplicationContext();

  /* istanbul ignore next */
  const slides = config.get<TCompareFlightSlides>(SLIDES_CONFIG_KEY) ?? SLIDES_DEFAULT;

  return <SliderModalLoadable slides={slides} onClose={onClose} />;
};
